module.exports = __webpack_public_path__ + "static/media/residenceimage.6d4db191.svg";